define(
    'NetSuite.SuiteCommCPQ.CartHandler',
    ['NetSuite.SuiteCommCPQ.ConfirmationModal', 'NetSuite.SuiteCommCPQ.Main.Debug'],
    function (ConfirmationModal, Debugger) {
    /**
     * @typedef {Object} SnapshotLine
     * @prop {number=} internalid
     * @prop {string} lineid
     * @prop {any=} configData
     * @prop {number=} configId
     */
    /**
     * Cart items in a developer-friendly format
     * @param {Line[]} lines
     */
    function SmartCartSnapshot(lines) {
        /**
         * Get config ID out of configData string
         * @param {string} configData
         * @return number|undefined
         */
        this.getConfigId = function(configData) {
            if (!configData) {
                return;
            }
            if (!isNaN(+configData)) {
                return +configData;
            }
            try {
                return +(JSON.parse(configData)).configId;
            } catch (e) {
            }
        }
        /**
         * @param {string} lineid
         */
        this.configByLine = function(lineid) {
            var item = this.items.find ( function (item) { return item.lineid == lineid; });
            return item ? item.configId : undefined;
        }
        /**
         * Get all items of the current configuration
         * @param {number} configId
         * @return string[]
         */
        this.getLineIdsOfConfig = function(configId) {
            return this.items.filter (function (item) { return item.configId == configId; }).map(function (item) { return item.lineid; });
        }
        // constructor
        Debugger.log('LINES', lines);
        var _this = this;
        /** @type {SnapshotLine[]} */
        this.items = lines.map (function(line) {
            /** @type {SnapshotLine} */
            var item = {
                internalid: line.item ? line.item.internalid : undefined,
                lineid: line.internalid
            };
            var configData;
            if (line.options) {
                var option = line.options.find(function (option) { return (option.cartOptionId === 'custcol_scpq_item_opt_config_data') });
                configData = option ? option.value.internalid : undefined;
            }
            if (configData) {
                item.configData = configData;
                item.configId = _this.getConfigId (configData);
            }
            return item;
        });
        Debugger.log('ITEMS', this.items);
    }
    function CartCancelEvent(message) {
        Error.apply(this, arguments);
        this.message = message;
        /** This property is required by `beforeUpdateLine` event so it doesn't crash */
        this.responseText = JSON.stringify ({
            errorDetails: {},
            errorMessage: this.message
        });
    }
    /**
     * Handles deleting and updating items in the cart. Items belonging to configuration
     * are most probably should be removed with the rest of the configuration. Item quantity
     * most probably should not be modified at all.
     * @param {Cart} cart
     * @param {Layout} layout
     * @param {{allowSeparateDelete: boolean, allowUpdate: boolean}} mode
     * @param {() => boolean} activator
     */
    function CartHandler(cart, layout, mode, activator) {
        this.cart = cart;
        this.layout = layout;
        this.mode = mode;
        this.activator = activator;
        /** @type {string[]|null} IDs of items being deleted at the moment */
        this.inProgress = null;
        this.initialize = function() {
            Debugger.log('SmartCart :: init');
            var _this = this;
            this.cart.cancelableOn('beforeRemoveLine', function(/** @type {{ line_id: string; }} */ data) {
                Debugger.log('EVENT : beforeRemoveLine:', data);
                if (!_this.activator()) {
                    Debugger.log ('Cart handler is not active');
                    return;
                }
                if (_this.inProgress) {
                    var dfd = jQuery.Deferred();
                    if (_this.inProgress.includes (data.line_id))
                        dfd.resolve();
                    else
                        dfd.reject();
                    return dfd;
                } else {
                    return jQuery.when (_this.processDeleteRequest(data.line_id));
                }
            });
            this.cart.cancelableOn ('beforeUpdateLine', function(updateLine) {
                Debugger.log('EVENT : beforeUpdateLine');
                if (!_this.activator()) {
                    Debugger.log ('Cart handler is not active');
                    return;
                }
                return jQuery.when (_this.processUpdateRequest(updateLine));
            });
        }
        this.confirm = function(text, cancelText, variants) {
            var _this = this,
                dfrd = new jQuery.Deferred();
            var confirmationView = new ConfirmationModal ({
                body: text,
                cancelText: cancelText,
                variants: variants,
                callback: dfrd.resolve
            });
            _this.layout.showContent (confirmationView, {showInModal: true, dontScroll: true});
            return dfrd;
        }
        this.getConfigLineIds = function(lineid) {
            var dfrd = new jQuery.Deferred();
            this.cart.getLines().then(function(lines) {
                if (!lines) {
                    dfrd.resolve(undefined);
                    return;
                }
                var snapshot = new SmartCartSnapshot(lines);
                var configId = snapshot.configByLine(lineid); // extract config ID
                if (!configId) { // item is not configurable
                    dfrd.resolve(undefined);
                    return;
                }
                Debugger.log('item from config:', configId);
                var configLineIds = snapshot.getLineIdsOfConfig(configId); // get all items of current configuration
                Debugger.log('items in config ' + configId+':', configLineIds);
                dfrd.resolve(configLineIds);
            });
            return dfrd;
        }
        this.processUpdateRequest = function(updateLine) {
            var _this = this;
            return this.getConfigLineIds(updateLine.line.internalid).then(function(configLineIds) {
                if (!configLineIds) {
                    return;
                }
                if (!_this.mode.allowUpdate) {
                    var message = "Can't update this item because it's a part of configuration";
                    _this.confirm(message, 'Dismiss', []);
                    throw new CartCancelEvent(message);
                }
            });
        }
        /**
         * Check if item is a part of the configuration before deleting it from the cart
         * @param {string} lineid
         */
        this.processDeleteRequest = function(lineid) {
            var _this = this;
            var dfrd = new jQuery.Deferred();
            this.getConfigLineIds(lineid).then(function(configLineIds){
                if (!configLineIds || configLineIds.length <= 1) { // item has no related items in the cart
                    dfrd.resolve();
                    return;
                }
                setTimeout(function() {
                    var variants = [
                        {key: 'all', value: 'Remove all '+configLineIds.length+' items'}
                    ];
                    if (_this.mode.allowSeparateDelete) {
                        variants.push ({key: 'one', value: 'Remove just one item'});
                    }
                    _this.confirm (
                        'Current item is part of a configuration of '+configLineIds.length+' items. Do you want to remove all the items of this configuration?',
                        null,
                        variants
                    ).then(function(confirmation) {
                        if (!confirmation) {
                            return;
                        }
                        _this.deleteBulk (confirmation == "all" ? configLineIds : [lineid]);
                    });
                });
                dfrd.reject();
                throw new CartCancelEvent ();
            });
            return dfrd;
        }
        /**
         * Deletes the items from the cart
         * @param {string[]} lineIds
         */
        this.deleteBulk = function(lineIds) {
            /** @todo write configuration record deleting (via back-end) */
            var _this = this;
            this.inProgress = lineIds;
            processSerial({
                callback: function (line) {
                    return _this.cart.removeLine(line);
                },
                params: lineIds.map(function(lineId) {return { line_id: lineId };}),
                success: function() { Debugger.log('* line removed successfully'); },
                fail: function() { Debugger.error('An error occurred while trying to remove the item. Try again.'); }
            }).then(function() {
                _this.inProgress = null;
            });
        }
    }
    /**
     * Runs an async callback multiple types using an array of arguments (for each run)
     * @param {object} options
     * @returns {jQuery.Deferred}
     */
    function processSerial(options) {
        var dfrd = new jQuery.Deferred(),
            callback = options.callback,
            params = options.params,
            success = options.success,
            fail = options.fail;
        loop(0);
        function loop(idx) {
            if (idx < params.length) {
                callback(params[idx]).then(function(result) {
                    if (success)
                        success(result);
                    loop(idx+1);
                }).catch(function(result) {
                    if (fail)
                        fail(result);
                    loop(idx+1);
                });
            } else {
                dfrd.resolve();
            }
        }
        return dfrd;
    }
    return CartHandler;
});
